var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradientSquiggle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 250.876,
    height: 62.244,
    viewBox: "0 0 250.876 62.244",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105",
    "data-name": "Rectangle 105",
    width: 250.876,
    height: 62.244
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 5.494,
    x2: 1,
    y2: 5.494,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbb45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ff7e45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#ff7b4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#fd725b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851,
    stopColor: "#fc6376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#f94e9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f94e9c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_489",
    "data-name": "Group 489",
    transform: "translate(-5.314 -321.844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_418",
    "data-name": "Group 418",
    transform: "translate(5.314 321.843)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    d: "M206.93,62.243q-.238,0-.476-.006a24.2,24.2,0,0,1-18.814-9.563l-29.22-38.1a16.255,16.255,0,0,0-25.5-.5L100.969,52.611a23.763,23.763,0,0,1-19,8.829A24.217,24.217,0,0,1,63.19,52.128L47.365,32.04a16.265,16.265,0,0,0-26.133.669L7.269,52.379a3.962,3.962,0,0,1-5.6.923,4.113,4.113,0,0,1-.909-5.688L14.721,27.942a24.149,24.149,0,0,1,19.215-10.3A23.881,23.881,0,0,1,53.63,26.949L69.456,47.037a16.264,16.264,0,0,0,12.61,6.253,16.756,16.756,0,0,0,12.76-5.929L126.775,8.83a24.208,24.208,0,0,1,37.978.738l29.22,38.1a16.259,16.259,0,0,0,25.5.493l24.315-29.327a3.974,3.974,0,0,1,5.656-.493,4.121,4.121,0,0,1,.486,5.743L225.615,53.41A24.182,24.182,0,0,1,206.93,62.243Z",
    transform: "translate(0 0.001)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientSquiggle);
export default __webpack_public_path__ + "static/media/gradientSquiggle.251d40684dc8a2ed5081620e272a9b00.svg";
export { ForwardRef as ReactComponent };